export enum ReportingCertTypeEnum {
    TERM = "term",
    COURSE = "course",
    GRADE = "grade",
    ELECTIVE = "elective",
    ASSIGNMENT = "assignment",
    UNIVERSITY = "university"
}
